import { theme } from '../../../../components/ThemeContext/ThemeObject';
import { styles as sharedClasses } from '../Modals/styles';

export const styles = {
  ...sharedClasses,
  integrationCard: {
    border: '1px solid #DDDDDD',
    borderRadius: '6px',
    padding: 2,
    rowGap: 1,
    width: '150px',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  integrationCardImageContainer: {
    padding: '16px 0px'
  },
  exportButton: {
    border: '1px solid #DDDDDD',
    borderRadius: '6px',
    padding: '8px 16px',
    width: 'fit-content',
    color: '#333333',
    fontWeight: 600,
    cursor: 'pointer'
  },
  modalDoubleColumn: {
    flexDirection: 'row',
    columnGap: 3
  },
  alreadyExportedModal: {
    padding: '48px 32px',
    width: '450px',
    alignItems: 'center',
    rowGap: 2
  },
  integrationDetails: {
    padding: 3,
    borderRadius: '6px',
    border: '1px solid #E3E3E3',
    rowGap: 1
  },
  integrationDetailsTable: {
    '&.responsive': { tableLayout: 'auto' },
    '& .MuiTableCell-root': {
      fontFamily: 'Source Sans Pro',
      padding: '4px 16px 16px 0px',
      border: 'none',
      fontWeight: 600
    }
  },
  integrationDetailsTableHeader: {
    color: theme.palette.primary.main,
    textTransform: 'capitalize',
    background: 'white'
  },
  verifyActivityButtonsContainer: {
    flexDirection: 'row',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    width: 'fit-content'
  },
  verifyActivityButton: {
    padding: '6px',
    width: '100px',
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: '6px'
  },
  cognologySectionTitle: {
    fontWeight: 'bold',
    color: '#666666',
    fontSize: '18px'
  },
  cognologyCategoriesContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: 2,
    columnGap: 2,
    paddingBottom: 1
  },
  cognologyAttachmentContainer: {
    flexDirection: 'row',
    columnGap: 1,
    width: '48%',
    alignItems: 'center'
  },
  migratingSystemFields: {
    flexDirection: 'row',
    columnGap: 1,
    alignItems: 'center',
    paddingBottom: '12px'
  },
  customFieldsContainer: { flexWrap: 'wrap', flexDirection: 'row', columnGap: 3, rowGap: 2 },
  autocompleteSlotProps: {
    listbox: { style: { maxHeight: '200px' } },
    popper: {
      modifiers: [
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            altAxis: true,
            tether: false,
            rootBoundary: 'viewport'
          }
        }
      ]
    }
  }
};
